import Input from 'components/shared/Input/Input';
import s from '../Vouchers.module.scss';
import Button from 'components/shared/Button/Button';
import CloseIcon from '../../../../../../images/new-icons/cross-thin-black.svg';
import { ReactComponent as ArrowDown } from '../../../../../../images/arrow-down-w.svg';
import { VoucherCard } from '../VoucherCard';
import { useParams } from 'react-router-dom';
import useGetSalonById from 'sdk/hooks/salon/useGetSalonById';
import { validateEmail } from 'sdk/utils/validation';
import { useState } from 'react';
import TimePickerModal from '../TimePicker';
import DatePickerModal from '../DatePicker';
import { format } from 'date-fns';
import useIsAuth from 'sdk/hooks/useIsAuth';

type DayType = {
  day: number;
  month: number;
  year: number;
} | null;

type TimeStepProps = {
  deliveryDate: any;
  setDeliveryDate: (date: any) => void;
  onNext: () => void;
  onBack: () => void;
  voucherData: any;
};

const TimeStep = ({
  deliveryDate,
  setDeliveryDate,
  onNext,
  onBack,
  voucherData,
  activeTime,
  setActiveTime,
  email
}) => {
  const { id } = useParams();
  const { data } = useGetSalonById(id);
  const { data: isAuthData } = useIsAuth();
  const fromUserID = isAuthData?.user?.id;
  const [isTimePickerOpen, setIsTimePickerOpen] = useState(false);
  const [selectedTime, setSelectedTime] = useState('');
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState<Date | null>(null);

  const handleTimeSelect = (time: string) => {
    setSelectedTime(time);
  };

const handleNext = () => {
  const defaultTime = "14:00"; 
  const timeToUse = selectedTime || defaultTime;

  if (activeTime === 'choose' && selectedDay) {
    setDeliveryDate({
      mode: activeTime,
      date: selectedDay.toISOString().split('T')[0],  
      time: timeToUse,
    });
  } else if (activeTime === 'now') {
    const today = new Date();
    setDeliveryDate({
      mode: 'now',
      date: today.toISOString().split('T')[0],
      time: timeToUse,
    });
  }

  onNext();
};

  const isNextDisabled = () => {
    if (activeTime === 'now') {
      return false;
    }
    return !selectedDay || !selectedTime;
  };

  return (
    <div className={s.vouchers_step}>
      <img src={CloseIcon} alt="email" onClick={onBack} className={s.vouchers_step_close} />
      <div className={s.vouchers_step_stage}>
        <div className={s.vouchers_step_stage_active}></div>
        <div className={s.vouchers_step_stage_active}></div>
        <div className={s.vouchers_step_stage_inactive}></div>
      </div>

      <div className={s.vouchers_step_voucher}>
        <VoucherCard
          style={{ marginTop: '25px' }}
          variant={voucherData?.color?.toLowerCase()}
          {...voucherData}
        />
      </div>

      <div className={s.vouchers_step_time}>
        <div
          className={`${s.vouchers_step_time_now} ${activeTime === 'now' ? s.active : ''}`}
          onClick={() => setActiveTime('now')}
        >
          Now
        </div>
        <div
          className={`${s.vouchers_step_time_choose} ${activeTime === 'choose' ? s.active : ''}`}
          onClick={() => setActiveTime('choose')}
        >
          Choose time
        </div>
      </div>

      <div className={s.vouchers_step_title}>
        We will send the Gift Card via your e-mail address
      </div>

      {activeTime === 'now' ? (
        <p className={s.vouchers_step_description2}>
          Today,{' '}
          {new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
          , right after the purchase.
        </p>
      ) : (
        <>
          <Input
            placeholder="Choose date"
            value={selectedDay ? format(selectedDay, 'dd MMM, yyyy') : ''}
            onClick={() => setIsDatePickerOpen(true)}
            gray
            wide
            style={{ marginTop: '16px' }}
            suffix={<ArrowDown />}
          />

          <Input
            style={{ marginTop: '16px' }}
            placeholder="Choose time"
            value={selectedTime}
            onClick={() => setIsTimePickerOpen(true)}
            gray
            wide
            suffix={<ArrowDown />}
          />
        </>
      )}

      <TimePickerModal
        isOpen={isTimePickerOpen}
        onClose={() => setIsTimePickerOpen(false)}
        onSelect={handleTimeSelect}
      />

      <DatePickerModal
        isOpen={isDatePickerOpen}
        onClose={() => setIsDatePickerOpen(false)}
        onSelect={setSelectedDay}
        selectedDay={selectedDay}
      />

      <Button
        className={s.vouchers_step_buttons}
        darkGreen
        wide
        onClick={handleNext}
        disabled={isNextDisabled()}
      >
        Next
      </Button>
    </div>
  );
};

export default TimeStep;
